import TagManager from "react-gtm-module";

function MajorsSearchCP({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "majors_search_cp",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default MajorsSearchCP;
